import React, { useContext, useState } from 'react';
import { Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import operationContext from '../../../context';
import initialEsrsContext from '../context';
import { PageHeader, Section, SpinnerArea } from '../../../../../../shared/components';
import Context from '../../../../../App/MainProvider/context';
import operInitialEsrsCommentsService from '../../../../../../services/operInitialEsrsCommentsService';
import useService from '../../../../../../shared/hooks/useService';
import toolkitService from '../../../../../../services/toolkitService';
import NotificationContext from '../../../../../Notifications/NotificationContext';
import CommentForm from '../../Comments/CommentForm';
import { FlowCommentForm } from '../../../../../../services/types/Flow';

const InitialEsrsCommentForm: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { service, notify } = useContext(Context);
  const { operation } = useContext(operationContext);

  const selectType = (): string => {
    if (operation.isEspf) {
      return 'ESPF_NFI';
    }

    return 'Classic';
  };

  const [topics, loading] = useService(() => toolkitService.getTopics(selectType()));

  const { data: initialEsrs } = useContext(initialEsrsContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { reload: reloadNotifications } = useContext(NotificationContext);

  if (!initialEsrs || !initialEsrs.content) {
    return null;
  }

  const handleSubmit = (values: FlowCommentForm) => {
    service(
      () =>
        operInitialEsrsCommentsService.create({
          ...values,
          keywords: values.keywords.map((x) => parseInt(x, 10)),
        }),
      {
        callback: () => {
          notify('Initial ESRS Comments', t('successCreatedComment'), 'success');
          reloadNotifications();
          navigate(`/operations/${operation.number}/initial-esrs/comments`);
        },
        loader: setIsSubmitting,
      }
    );
  };

  return (
    <SpinnerArea loading={loading}>
      {topics && (
        <Container className="dashboard">
          <PageHeader
            title={t('flowCommentFormTitle', {
              number: operation.number,
              flowType: 'Initial ESRS',
            })}
          />
          <Row>
            <Section title={t('flowCommentFormSectionTitle')} className="section-form">
              <hr />
              <CommentForm
                handleSubmit={handleSubmit}
                operationId={operation.id}
                isSubmitting={isSubmitting}
                topics={topics}
                topicTitle={t('standard')}
              />
            </Section>
          </Row>
        </Container>
      )}
    </SpinnerArea>
  );
};

export default InitialEsrsCommentForm;
